export default __webpack_public_path__ + "static/media/wallpaper.cb2ff367.jpg";